'use strict';

/* global $ */

import { popup } from 'settings';

function Popup(options) {

    let opt = $.extend(true, popup, options);

    function initBlock() {

        console.log('[ Popup/Init ]');

        $('body').append(popup.html);
        $(popup.selector+'__close').on('click', function(e){
            e.preventDefault();
            $(popup.selector).removeClass('is-open');
            $('body').removeClass('m--popup');
            console.log('[ Popup/Close ]');
        });
    }

    initBlock();
}

export {
    Popup
};
